import { BookabilityDecision, type BookabilityStatusItem } from "@src/appV2/OpenShifts/ShiftAction";

import { getBackgroundCheckContext } from "../getBackgroundCheckContext";

/**
 * Checks if the shift booking is allowed, considering background check context.
 * A shift is considered bookable when:
 * 1. The bookability decision is ALLOWED, OR
 * 2. The shift is blocked ONLY due to missing background check data (which can be collected during booking flow)
 *
 * Note: The `isBlockedOnlyDueToMissingData` from `getBackgroundCheckContext` is only true when missing background
 * check data is the SOLE blocking requirement. If there are any other unmet criteria (e.g., missing documents,
 * worker deactivated, etc.), this will be false. This prevents the function from incorrectly returning true
 * and ignoring other blocking requirements.
 *
 * @param bookabilityStatus - The bookability status to check
 * @returns true if booking is allowed with background check considerations
 */
export function isBookabilityAllowedWithBackgroundCheck(
  bookabilityStatus: BookabilityStatusItem | undefined
): boolean {
  const backgroundCheckContext = getBackgroundCheckContext(bookabilityStatus);
  return (
    bookabilityStatus?.attributes.bookability.decision === BookabilityDecision.ALLOWED ||
    backgroundCheckContext.isBlockedOnlyDueToMissingData
  );
}
